'use client';

import { createZustandStore } from '@northladder/services';

import { loadAppThemeStore, updateColorSchemeCallback } from './callbacks';
import { IThemeState } from './types';

/**
 * Custom hook that provides options for switching theme, color palette and
 * callbacks to update them.
 */
export const useThemeStore = createZustandStore<IThemeState>((set) => {
  const { colorScheme } = loadAppThemeStore() || {};

  return {
    colorScheme: colorScheme || undefined,
    setColorScheme: updateColorSchemeCallback(set),
  };
});
